class CricketeriaMenu extends HTMLElement {
  constructor() {
    super();
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.tabs = [...this.querySelectorAll('.cmega__tab')];
    this.panels = [...this.querySelectorAll('.cmega__panel')];
    this.toggleBtn = this.querySelector('[data-menu-toggle]');
    this.overlay = this.querySelector('.cmega__overlay');

    // Inject a Back button at the top of each panel (visible on mobile via CSS)
    this.panels.forEach((panel) => {
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'cmega__back';
      back.innerHTML = '<span aria-hidden="true">‹</span> Back';
      back.addEventListener('click', () => this.closeAll());
      panel.prepend(back);
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.onTabClick(tab));
      tab.addEventListener('mouseenter', () => { if (this.desktop.matches) this.open(tab); });
      tab.addEventListener('focus', () => { if (this.desktop.matches) this.open(tab); });
    });

    this.addEventListener('mouseleave', () => { if (this.desktop.matches) this.closeAll(); });
    this.toggleBtn?.addEventListener('click', () => this.toggleDrawer());
    this.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', () => this.toggleDrawer(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.closeAll(); this.toggleDrawer(false); } });
  }

  panelFor(tab) { return this.querySelector('#' + tab.getAttribute('aria-controls')); }

  open(tab) {
    this.tabs.forEach((t) => t.setAttribute('aria-expanded', String(t === tab)));
    this.panels.forEach((p) => { p.hidden = p !== this.panelFor(tab); });
  }

  closeAll() {
    this.tabs.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    this.panels.forEach((p) => { p.hidden = true; });
  }

  onTabClick(tab) {
    const isOpen = tab.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.closeAll();
    } else {
      this.open(tab);
    }
  }

  toggleDrawer(force) {
    const next = force ?? !this.classList.contains('is-open');
    this.classList.toggle('is-open', next);
    this.toggleBtn?.setAttribute('aria-expanded', String(next));
    if (this.overlay) this.overlay.hidden = !next;
    document.body.style.overflow = next ? 'hidden' : '';
    if (!next) this.closeAll();
  }
}
customElements.define('cricketeria-menu', CricketeriaMenu);
